
var TAG_FRETE_GRATIS_PERSONALIZADA = true;

/* Fechar sidebars ao clicar no overlay/fundo escuro */
document.addEventListener('click', function(e) {
  /* Carrinho - dark-overlay */
  if (e.target.classList.contains('dark-overlay')) {
    try {
      wsMain.modules['cart-drawer'].changeState();
    } catch(err) {}
  }

  /* Filtros - fundo-escuro (checkbox controlado) */
  if (e.target.classList.contains('fundo-escuro')) {
    var checkbox = document.getElementById('aba-lateral-input');
    if (checkbox && checkbox.checked) {
      checkbox.checked = false;
    }
  }
});

/* Corrige mascara do CEP no frete do carrinho */
function corrigirMascaraCepCarrinho() {
  var cepVisual = document.querySelector('#frete-section #cep');
  var cepOriginal = document.querySelector('#LV_CAMPO_CEP');

  if (!cepVisual) return;

  function limparCep(valor) {
    return String(valor || '').replace(/\D/g, '').slice(0, 8);
  }

  function mascararCep(valor) {
    var cep = limparCep(valor);
    return cep.length > 5 ? cep.slice(0, 5) + '-' + cep.slice(5) : cep;
  }

  function sincronizarCep(valor) {
    var cepFormatado = mascararCep(valor);
    cepVisual.value = cepFormatado;

    if (cepOriginal) {
      cepOriginal.value = cepFormatado;
    }
  }

  sincronizarCep(cepVisual.value || (cepOriginal && cepOriginal.value));

  if (cepVisual.dataset.mascaraCepCarrinhoAplicada === '1') return;
  cepVisual.dataset.mascaraCepCarrinhoAplicada = '1';

  cepVisual.addEventListener('input', function() {
    sincronizarCep(cepVisual.value);
  });

  cepVisual.addEventListener('blur', function() {
    sincronizarCep(cepVisual.value);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', corrigirMascaraCepCarrinho);
} else {
  corrigirMascaraCepCarrinho();
}

setTimeout(corrigirMascaraCepCarrinho, 500);
setTimeout(corrigirMascaraCepCarrinho, 1500);

/* Ajusta o texto do aviso de cookies */
function ajustarAvisoCookiesCentralizado() {
  var caixa = document.querySelector('#aceite_privacidade');
  var texto = caixa ? caixa.querySelector('p') : null;

  if (!texto) return;

  texto.querySelectorAll('br').forEach(function(quebra) {
    quebra.replaceWith(' ');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ajustarAvisoCookiesCentralizado);
} else {
  ajustarAvisoCookiesCentralizado();
}

setTimeout(ajustarAvisoCookiesCentralizado, 500);
setTimeout(ajustarAvisoCookiesCentralizado, 1500);

/* Substitui o texto sem juros por s/juros */
function aplicarRegraSemJuros() {
  if (!document.body || !window.MutationObserver || !window.NodeFilter) return;

  if (window.regraSemJuros) {
    window.regraSemJuros.disconnect();
  }

  function substituir(raiz) {
    if (!raiz) return;

    var walker = document.createTreeWalker(
      raiz,
      NodeFilter.SHOW_TEXT
    );
    var no;

    while ((no = walker.nextNode())) {
      var tagPai = no.parentElement ? no.parentElement.tagName : '';
      var tagIgnorada = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT'].indexOf(tagPai) !== -1;

      if (!tagIgnorada && /sem juros/i.test(no.nodeValue)) {
        no.nodeValue = no.nodeValue.replace(/sem juros/gi, 's/juros');
      }
    }
  }

  substituir(document.body);

  window.regraSemJuros = new MutationObserver(function(mutacoes) {
    mutacoes.forEach(function(mutacao) {
      if (
        mutacao.type === 'characterData' &&
        /sem juros/i.test(mutacao.target.nodeValue)
      ) {
        mutacao.target.nodeValue = mutacao.target.nodeValue.replace(
          /sem juros/gi,
          's/juros'
        );
      }

      mutacao.addedNodes.forEach(function(no) {
        if (
          no.nodeType === Node.TEXT_NODE &&
          /sem juros/i.test(no.nodeValue)
        ) {
          no.nodeValue = no.nodeValue.replace(/sem juros/gi, 's/juros');
        } else if (no.nodeType === Node.ELEMENT_NODE) {
          substituir(no);
        }
      });
    });
  });

  window.regraSemJuros.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', aplicarRegraSemJuros);
} else {
  aplicarRegraSemJuros();
}

/* Cliente logado: clicar no botão de login do header vai direto pra
   "Meus Dados" em vez de abrir a sidebar de identificação (que só faz
   sentido pra quem ainda não está logado). Mesmo comportamento que já
   existia no popup de login antigo da loja. */
function redirecionarLoginParaMenuCliente() {
  var nomeEl = document.querySelector('#HD_LVCLI_NOME');
  if (!nomeEl || nomeEl.value === 'Visitante') return;

  var container = document.querySelector('[data-wsjs-login="container"]');
  var loginBtn = container && container.querySelector('.login-options-button');
  if (!loginBtn || loginBtn.dataset.menuClienteBound) return;

  loginBtn.dataset.menuClienteBound = '1';
  loginBtn.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = '/menu-cliente';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', redirecionarLoginParaMenuCliente);
} else {
  redirecionarLoginParaMenuCliente();
}
